export default __webpack_public_path__ + "static/media/video.d28831bc.mp4";